import { combineEpics, ofType } from 'redux-observable';
import { map, catchError, switchMap, takeUntil } from 'rxjs/operators';
import { createErrorStream } from 'common/store/error';

import {
  LOAD,
  CLEAR,
  loadSuccess,
  loadError,
} from './actions';

const loadJob = (action, state, { jobService }) => action.pipe(
  ofType(LOAD),
  switchMap(action$ => jobService
    .getById(action$.jobId)
    .pipe(
      map(loadSuccess),
      takeUntil(action.pipe(ofType(CLEAR))),
      catchError(createErrorStream(action$, loadError)),
    )),
);

export default combineEpics(
  loadJob,
);
